<script>
  import { onMount } from "svelte";
  import gsap from "gsap";
  import { ScrollTrigger } from "gsap/ScrollTrigger";
  import {BizTextInsert} from "./components/TextInsert";
  BizTextInsert();
  const feature_01 = "/assets_default/images/business/top/feature_01.webp"
  const feature_02 = "/assets_default/images/business/top/feature_02.webp"
  const feature_03 = "/assets_default/images/business/top/feature_03.webp"
  const cardList = [
    {
      title: "最短翌営業日に口座開設<sup>※3</sup><br>オンライン完結ですぐに使える",
      img: {
        src: feature_01,
        alt: "最短翌営業日に口座開設※3オンライン完結ですぐに使える"
      },
      text: "銀行への来店は不要、申込みはオンラインで完結。最短翌営業日に口座開設となり、手続​き完了後、すぐにサービスが利用できます。設立直後のスタートアップでも申込みできるため、初めての方でも安心です。",
      link: {
        url: "/business/open-account/notes/",
        text: "口座開設について"
      }
    },
    {
      title: "振込金額に関わらず<br>業界最安水準<sup>※5</sup>の<span data-string='bizFeesOther'></span>円/回",
      img: {
        src: feature_02,
        alt: "振込金額に関わらず業界最安値水準"
      },
      text: "他行宛振込手数料は、1回あたり<span data-string='bizFeesOther'></span>円（税込）です。自行宛振込手数料やサービス利用料はかからないため、コスト管理もシンプルになります。急な支払いにも振込金額を気にすることなく、気軽にお使いいただけます。",
      link: {
        url: "/business/rates-and-fees/",
        text: "金利・手数料について"
      }
    },
    {
      title: "パスワード不要の手軽さと<br>万全のセキュリティを両立",
      img: {
        src: feature_03,
        alt: "パスワード入力不要の手軽さと万全のセキュリティを両立"
      },
      text: "パスキー認証<sup>※6</sup>でストレスフリーにログインできます。フィッシング詐欺や認証情報の漏洩のリスクが大幅に減少し、パスワードも不要<sup>※7</sup>です。"
    }
  ]
  onMount(() => {
    gsap.registerPlugin(ScrollTrigger);

    gsap.to(".is-up", {
      y: 0,
      opacity: 1,
      duration: 1.5,
      ease: "power4.out",
      scrollTrigger: {
        trigger: ".is-up",
        start: "top 80%",
      }
    })
  });
</script>

<section class="owd-biz-section:bg-gray" id="feature">
  <div class="owd-biz-section:max:1200">
    <section-head biz="true" title="特徴" caption="FEATURE"></section-head>
    <div class="owd-card-wrap:column:3 spacing:bottom:40 is-up">
      {#each cardList as item,index}
      <div class="owd-card owd-cv:primary owd-card:biz-feature">
        <div class="block:center spacing:bottom:24">
          <div class="owd-servicesticker owd-servicesticker:yellow owd-servicesticker:en">
            <p class="owd-label:en owd-servicesticker-label">FEATURE 0{index + 1}</p>
          </div>
        </div>
        <img class="spacing:bottom:24" src="{item.img.src}" width="163" height="109" alt={item.img.alt}>

        <h3 class="owd-heading:03 spacing:bottom:16"><strong>{@html item.title}</strong></h3>
        <p class={item.link ? "owd-text:02 spacing:bottom:24" : "owd-text:02"}>{@html item.text}</p>
        {#if item.link}
        <p class="owd-text:02"><strong><a href={item.link.url} class="owd-textlink">{item.link.text}</a></strong></p>
        {/if}
      </div>
      {/each}
    </div>
    <ul class="owd-list:annotation:number spacing:bottom:24">
      <li>
        <span class="owd-list:annotation:number-text" data-annotation-number="3">
          口座開設には審査があります。口座開設を約束するものではありません。
        </span>
      </li>
      <li>
        <span class="owd-list:annotation:number-text" data-annotation-number="4">
          他行宛・3万円以上の場合（2026年4月1日時点）
        </span>
      </li>
      <li>
        <span class="owd-list:annotation:number-text" data-annotation-number="5">
          2026年4月1日時点
        </span>
      </li>
      <li>
        <span class="owd-list:annotation:number-text" data-annotation-number="6">
          パスキー認証とは：従来のパスワードに代わる、国際標準規格に基づく次世代の認証方式です。端末の生体認証（指紋・顔等）等を活用し、パスワード入力の手間を排除。フィッシング詐欺や認証情報漏洩のリスクを大幅に低減し、高いセキュリティと利便性を両立させ、デジタル環境におけるユーザーの安心と快適な利用環境を確保します。
        </span>
      </li>
      <li>
        <span class="owd-list:annotation:number-text" data-annotation-number="7">
          初回ログイン時など、一部パスワードを使用するケースがあります。
        </span>
      </li>
    </ul>
  </div>
</section>

<style lang="scss">
.is-up{
  opacity: 0;
    transform: translateY(100px);
}
@include g.mobile () {
  .owd-card-wrap\:column\:3{
    grid-template-columns: 1fr;
    gap: 8px;
  }
}
</style>
